import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, PromosService, PromoBudgetService, ReportXpressService } from 'app/services';
import {
    DayOfWeekEnum,
    PromoAvailableTypeEnum,
    PromoTypeEnum, PromoTypeModel, RiderServiceTypeModel, RiderVehicleType,
    RiderVehicleTypeEnum,
    ServiceTypeEnum, TimeZoneOffsetModel
} from 'app/models';
import * as moment from 'moment';
import { ServiceTypePromotionsComponent } from 'app/service-type';
import { Utils } from 'app/utils';

enum MenuTab {
    PromoDetails = 1,
    Mechanics = 2,
    Validity = 3,
    Products = 4,
    Locations = 5,
    Preview = 6
}

@Component({
    selector: 'service-type-promotion-add-update',
    templateUrl: './service-type-promotion-add-update.component.html',
    styleUrls: ['./service-type-promotion-add-update.component.scss',
        '../../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})
export class ServiceTypePromotionAddUpdateComponent implements OnInit {
    public isMerchant: boolean = false;
    public merchantId: number = 0;

    public promoId: number = 0;
    @Input()
    set _promoId(value: number) {
        if (value > 0) {
            this.promoId = value;
            this.getPromo();
        }
    }

    public showAddEditPromotionSideBar: boolean = false;
    @Input()
    set _showAddEditPromotionSideBar(value: boolean) {
        this.showAddEditPromotionSideBar = value;
    }

    @Input()
    set _promoTypeId(value: PromoTypeEnum) {
        this.changePromoType(value, 0);
    }

    @Input() public serviceTypePromotionsComponent!: ServiceTypePromotionsComponent;

    @Output() changedShowAddEditPromotionSideBarEmit = new EventEmitter<boolean>();
    changedShowAddEditPromotionSideBar(increased: any) {
        this.changedShowAddEditPromotionSideBarEmit.emit(increased);
    }

    public sideBarHeaderTitle: string = 'Choose a Promotion Type';

    public promoTypeEnum = PromoTypeEnum;
    public promoAvailableType = PromoAvailableTypeEnum;
    public activePromoType!: PromoTypeEnum;
    public selectedServiceType!: ServiceTypeEnum;
    public serviceTypeImageLink: string = '';

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.PromoDetails;

    public daysWeek: any[] = [
        { name: 'Mon', value: DayOfWeekEnum.Monday },
        { name: 'Tue', value: DayOfWeekEnum.Tuesday },
        { name: 'Wed', value: DayOfWeekEnum.Wednesday },
        { name: 'Thu', value: DayOfWeekEnum.Thursday },
        { name: 'Fri', value: DayOfWeekEnum.Friday },
        { name: 'Sat', value: DayOfWeekEnum.Saturday },
        { name: 'Sun', value: DayOfWeekEnum.Sunday }
    ];

    public serviceTypesEnum = ServiceTypeEnum;
    public timeZoneList = TimeZoneOffsetModel.TimeZoneOffsetList;

    public serviceTypes = RiderServiceTypeModel.RiderServiceTypeShortList;
    public vehicleTypes = RiderVehicleType.RiderVehicleTypeList.filter(f => f.id !== RiderVehicleTypeEnum.None);
    public promoTypes = PromoTypeModel.PromoTypeShortList;

    public locations: any[] = [];
    public geoZones: any[] = [];
    public promoBudgets: any[] = [];

    public serviceAndVehicleTypes: Array<any> = (this.appData.isBoracayLocation)
        ? RiderVehicleType.ServiceAndVehicleTypeBoracayList
        : RiderVehicleType.ServiceAndVehicleTypeXpressList;

    public promo: any = {};

    public showLimit: boolean = false;
    public showLimitPerDay: boolean = false;
    public showBetweenTimeOfday: boolean = false;

    public loading: boolean = false;
    public customUsersFile: File | null = null;
    public customUsersFileName: string = '';
    public customUsersDragOver: boolean = false;

    constructor(private messageService: MessageService, public appData: AppDataService,
        public promosService: PromosService, public promoBudgetService: PromoBudgetService,
        public reportService: ReportXpressService) {
        this.merchantId = parseInt(this.appData.authData.MerchantId, 10);
        this.isMerchant = this.appData.isMerchant();
    }

    ngOnInit(): void {
        this.getGeoZonesForPromo();
        this.getPromoBudgets();
    }

    public getPromoBudgets() {
        const dto = {
            SearchName: '',
            IsActive: true,
            Skip: 0,
            Take: 1000,
            SortField: 'Name',
            SortOrder: 1
        };

        this.promoBudgetService.getBudgets(dto, this.messageService).then(data => {
            if (!data || !data.Success) {
                return;
            }
            this.promoBudgets = (data.Items || []).map((x: any) => ({
                Id: x.Id,
                Label: x.Name + ' (' + x.Currency + ' ' + x.CurrentBalance + ')'
            }));
        });
    }

    public getGeoZonesForPromo() {
        const dto = {
            ClientLocationType: this.appData.getClientLocationType()
        };

        this.promosService.getGeoZonesForPromo(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                this.loading = false;
                return;
            }
            this.geoZones = data.Items;
        });
    }

    //временный метод, пока не переключимся на changePromoType
    setPromoType(item: PromoTypeEnum) {
        this.activePromoType = item;
        this.promo.PromoTypeId = this.activePromoType;
        if (item === PromoTypeEnum.Discount) {
            this.sideBarHeaderTitle = 'Discount';
        }
    }

    public changePromoType(item: PromoTypeEnum, serviceType: ServiceTypeEnum) {
        this.selectedServiceType = serviceType;
        this.promo.ServiceTypeId = serviceType;
        this.activePromoType = item;
        this.promo.PromoTypeId = this.activePromoType;
        this.setHeaderParams(item, serviceType);
    }

    public setHeaderParams(promoType: PromoTypeEnum, serviceType: ServiceTypeEnum) {
        if (promoType === PromoTypeEnum.PercentageDiscount) {
            if (serviceType === ServiceTypeEnum.Ride) {
                this.serviceTypeImageLink = '/XpressApp/assets/images/promo/percentage-discount-ride.svg';
            }
            else if (serviceType === ServiceTypeEnum.Delivery) {
                this.serviceTypeImageLink = '/XpressApp/assets/images/promo/percentage-discount-send.svg';
            }

            this.sideBarHeaderTitle = 'Percentage Discount';
        }
        else if (promoType === PromoTypeEnum.FixedAmountDiscount) {
            if (serviceType === ServiceTypeEnum.Ride) {
                this.serviceTypeImageLink = '/XpressApp/assets/images/promo/fix-amount-discount-ride.svg';
            }
            else if (serviceType === ServiceTypeEnum.Delivery) {
                this.serviceTypeImageLink = '/XpressApp/assets/images/promo/fix-amount-discount-send.svg';
            }

            this.sideBarHeaderTitle = 'Fixed Amount Discount';
        }
    }

    public onStartDateChange() {
        this.promo.StartedAtStr = moment(this.promo.StartedAt).format('DD MMM YYYY');
    }

    public onEndDateChange() {
        this.promo.ValidUntilStr = moment(this.promo.ValidUntil).format('DD MMM YYYY');
    }

    public getServiceTypeName() {
        switch (this.selectedServiceType) {
            case ServiceTypeEnum.Ride: return 'Ride ';
            case ServiceTypeEnum.Delivery: return 'Send ';
            default: return '';
        }
    }

    public handlePromoLocationChange() {
        const location = (this.locations) ? this.locations.find((f: any) => f.GeoZoneId === this.promo.Location.Id) : null;
        if (!location) {
            this.locations.push({
                GeoZoneId: this.promo.Location.Id,
                Name: this.promo.Location.Name
            });
        }
    }

    public deleteLocation(index: number) {
        const obj = this.locations[index];
        this.locations.splice(index, 1);
    }

    public changeActiveMenuTab(item: MenuTab) {
        if (item === MenuTab.Mechanics &&
            (!this.promo.Name || !this.promo.Code || !this.promo.Description)) {
            const errMsg = 'Promo Name, Promo Code, Description must have a value';
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: errMsg });
            return;
        }
        else if (item === MenuTab.Validity) {
            if (this.promo.MinSpend <= 0 || this.promo.CountUserUse <= 0) {
                const errMsg = 'Minimum Spend, How many times the promo can be used? Should have value of greater than zero.';
                this.messageService.add({ severity: 'error', summary: 'Warning', detail: errMsg });
                return;
            }
            else if (!this.promo.Name || !this.promo.Code || !this.promo.MinSpend || !this.promo.MaxAmount ||
                !this.promo.Description || !this.promo.PromoAvailableType || !this.promo.CountUserUse) {
                const errMsg = 'Promo Name, Promo Code, Minimum spend, Maximum Amount, Description, How many times the promo can be used?. must have a value';
                this.messageService.add({ severity: 'error', summary: 'Warning', detail: errMsg });
                return;
            }
            else if (this.isCustomUsersFileMissing()) {
                this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Upload an Excel file with user ids' });
                return;
            }
        }
        else if (item === MenuTab.Products &&
            (!this.promo.Name || !this.promo.Code || !this.promo.Description)) {
            const errMsg = 'Promo Name, Promo Code, Service Type, Description must have a value';
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: errMsg });
            return;
        }
        else if ((item === MenuTab.Locations || item === MenuTab.Preview) &&
            (!this.promo.Name || !this.promo.Code || !this.promo.ServiceAndVehicleTypes || !this.promo.MinSpend || !this.promo.MaxAmount || !this.promo.Description ||
                !this.promo.StartedAt || !this.promo.ValidUntil)) {
            const errMsg = 'Promo Name, Promo Code, Service Type, Minimum spend, Maximum Amount, Description, Start Date, End Date must have a value';
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: errMsg });
            return;
        }

        this.activeMenuTab = item;
    }

    public limitClick(isShow: boolean) {
        if (!isShow) {
            this.promo.MaxUseCount = 0;
            this.showLimit = false;
        }
        else {
            this.promo.MaxUseCount = null;
            this.showLimit = true;
        }
    }
    public limitPerDayClick(isShow: boolean) {
        if (!isShow) {
            this.promo.MaxUsePerDayCount = 0;
            this.showLimitPerDay = false;
        }
        else {
            this.promo.MaxUsePerDayCount = null;
            this.showLimitPerDay = true;
        }
    }
    public betweenTimeOfDayClick(isShow: boolean) {
        this.promo.BetweenStartTime = null;
        this.promo.BetweenEndTime = null;
        this.showBetweenTimeOfday = isShow;
    }

    public handleImageClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.promo.CoverUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public get savedCustomUserCount(): number {
        const raw = this.promo?.CustomUserIds;
        if (!raw || typeof raw !== 'string') {
            return 0;
        }

        return raw.split(',').map((id: string) => id.trim()).filter((id: string) => id.length > 0).length;
    }

    public onCustomUsersFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files && input.files.length > 0 ? input.files[0] : null;
        if (!file) {
            this.clearCustomUsersFile();
            return;
        }

        if (!this.applyCustomUsersFile(file)) {
            input.value = '';
        }
    }

    public onCustomUsersDragOver(event: DragEvent): void {
        event.preventDefault();
        this.customUsersDragOver = true;
    }

    public onCustomUsersFileDrop(event: DragEvent): void {
        event.preventDefault();
        this.customUsersDragOver = false;
        const file = event.dataTransfer?.files?.[0];
        if (file) {
            this.applyCustomUsersFile(file);
        }
    }

    public clearCustomUsersFile(event?: Event): void {
        event?.stopPropagation();
        this.customUsersFile = null;
        this.customUsersFileName = '';
        this.customUsersDragOver = false;
        const input = document.getElementById('customUsersFileInput') as HTMLInputElement | null;
        if (input) {
            input.value = '';
        }
    }

    private applyCustomUsersFile(file: File): boolean {
        const extension = file.name.split('.').pop()?.toLowerCase();
        if (extension !== 'xls' && extension !== 'xlsx') {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Upload an Excel file (.xls or .xlsx).' });
            return false;
        }

        this.customUsersFile = file;
        this.customUsersFileName = file.name;
        return true;
    }

    private isCustomUsersFileMissing(): boolean {
        return this.promo.PromoAvailableType === PromoAvailableTypeEnum.CustomUsers
            && !this.customUsersFile
            && !this.promo.CustomUserIds;
    }

    private readFileAsBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = String(reader.result || '');
                const comma = result.indexOf(',');
                resolve(comma >= 0 ? result.substring(comma + 1) : result);
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });
    }

    public getPromo() {
        this.loading = true;

        const dto = {
            PromoId: this.promoId
        };
        this.promosService.getPromo(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.promo = data.Promo;
                this.promo.ServiceAndVehicleTypes = [];
                this.setPromoType(this.promo.PromoTypeId);

                if (!this.promo.MaxUseCount) {
                    this.showLimit = false;
                    this.promo.selectedLimit = false;
                }
                else {
                    this.showLimit = true;
                    this.promo.selectedLimit = true;
                }

                if (!this.promo.MaxUsePerDayCount) {
                    this.showLimitPerDay = false;
                    this.promo.selectedLimitPerDay = false;
                }
                else {
                    this.showLimitPerDay = true;
                    this.promo.selectedLimitPerDay = true;
                }
                this.locations = this.promo.XpressPromoGeoZones;
                if (this.promo.StartedAt) {
                    this.promo.StartedAt = Utils.utcToLocalDateByTimeZone(this.promo.StartedAt, this.promo.TimeZoneOffset);
                    this.promo.StartedAtTime = this.promo.StartedAt;
                    this.onStartDateChange();
                }
                if (this.promo.ValidUntil) {
                    this.promo.ValidUntil = Utils.utcToLocalDateByTimeZone(this.promo.ValidUntil, this.promo.TimeZoneOffset);
                    this.promo.ValidUntilTime = this.promo.ValidUntil;
                    this.onEndDateChange();
                }

                if (this.promo.BetweenStartTime) {
                    const betweenStartTimeUtc = new Date(this.promo.BetweenStartTime);
                    this.promo.BetweenStartTime = Utils.utcToLocalDateByTimeZone(betweenStartTimeUtc, this.promo.TimeZoneOffset);
                }
                if (this.promo.BetweenEndTime) {
                    const betweenEndTimeUtc = new Date(this.promo.BetweenEndTime);
                    this.promo.BetweenEndTime = Utils.utcToLocalDateByTimeZone(betweenEndTimeUtc, this.promo.TimeZoneOffset);
                }

                if (this.promo.XpressPromoServiceAndVehicleTypes) {
                    this.promo.XpressPromoServiceAndVehicleTypes.map((m: any) => {
                        const foundServiceAndVehicle = this.serviceAndVehicleTypes
                            .find(f => m.ServiceType === f.serviceType && m.VehicleType === f.vehicleType && m.IsScanAndRide === f.isScanAndRide);
                        if (foundServiceAndVehicle) {
                            this.promo.ServiceAndVehicleTypes.push(foundServiceAndVehicle);
                        }
                    });
                }

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public clickSavePromo(): void {
        const startedAt = this.promo.StartedAt;
        const endedAt = this.promo.ValidUntil;
        if (this.promo.ValidUntil) {
            if (this.promo.ValidUntilTime) {
                this.promo.ValidUntil.setHours(this.promo.ValidUntilTime.getHours());
                this.promo.ValidUntil.setMinutes(this.promo.ValidUntilTime.getMinutes());
            }
            else {
                this.promo.ValidUntil.setHours(23);
                this.promo.ValidUntil.setMinutes(59);
            }
            this.promo.ValidUntil = moment(this.promo.ValidUntil).format('YYYY-MM-DDTHH:mm:ss');
        }
        if (this.promo.StartedAt) {
            if (this.promo.StartedAtTime) {
                this.promo.StartedAt.setHours(this.promo.StartedAtTime.getHours());
                this.promo.StartedAt.setMinutes(this.promo.StartedAtTime.getMinutes());
            }
            else {
                this.promo.StartedAt.setHours(0);
                this.promo.StartedAt.setMinutes(0);
            }
            this.promo.StartedAt = moment(this.promo.StartedAt).format('YYYY-MM-DDTHH:mm:ss');
        }

        if (this.promo.BetweenStartTime) {
            this.promo.BetweenStartTime = moment(this.promo.BetweenStartTime).format('YYYY-MM-DDTHH:mm:ss');
        }
        if (this.promo.BetweenEndTime) {
            this.promo.BetweenEndTime = moment(this.promo.BetweenEndTime).format('YYYY-MM-DDTHH:mm:ss');
        }

        this.promo.UsePercent = (this.promo.UsePercent) ? this.promo.UsePercent : 0;
        this.promo.UseAmount = (this.promo.UsePercent && this.promo.UsePercent > 0) ? 0 : this.promo.UseAmount;
        this.promo.UseFlatAmount = (this.promo.UseFlatAmount) ? this.promo.UseFlatAmount : 0;
        this.promo.CappedAmount = (this.promo.CappedAmount) ? this.promo.CappedAmount : 0;
        this.promo.XpressPromoGeoZones = this.locations;
        this.promo.TimeZoneOffset = Utils.getPhilippinesTimezoneHour();

        if ((this.promo.UsePercent > 0 || this.promo.UseAmount > 0) && this.promo.UseFlatAmount > 0) {
            this.messageService.add({
                severity: 'error', summary: 'Warning',
                detail: 'Three fields are filled in at the same time. Please fill in one of the three fields (Use Percent, Value of Discount or Flat Amount)'
            });
            this.promo.StartedAt = startedAt;
            this.promo.ValidUntil = endedAt;
            return;
        }

        if (!this.promo.Name || !this.promo.Code || !this.promo.Description || !this.promo.PromoTypeId || !this.promo.ServiceAndVehicleTypes
            || !this.promo.MinSpend || !this.promo.MaxAmount) {
            const errMsg = 'Name, Promo Code, Promo Type, Minimum spend, Maximum Amount, Description must have a value, Service and vehicle type';
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: errMsg });
            this.promo.StartedAt = startedAt;
            this.promo.ValidUntil = endedAt;
            return;
        }

        if (!this.promo.PromoBudgetId) {
            this.messageService.add({
                severity: 'error',
                summary: 'Warning',
                detail: 'Budget is required before this promo can be saved'
            });
            this.promo.StartedAt = startedAt;
            this.promo.ValidUntil = endedAt;
            return;
        }

        if (this.isCustomUsersFileMissing()) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Upload an Excel file with user ids' });
            this.promo.StartedAt = startedAt;
            this.promo.ValidUntil = endedAt;
            return;
        }

        this.promo.XpressPromoLocations = this.locations;

        const submitPromo = () => {
            this.loading = true;

            this.promosService.addOrUpdatePromo(this.promo, this.messageService)
            .then(data => {
                this.promo.StartedAt = startedAt;
                this.promo.ValidUntil = endedAt;
                if (!data) {
                    this.loading = false;
                    return;
                }
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.loading = false;
                this.serviceTypePromotionsComponent.showAddEditPromotionSideBar = false;
                this.serviceTypePromotionsComponent.getPromos(0);
                this.cancel();
            })
            .finally(() => {
                delete this.promo.CustomUsersExcelBase64;
            });
        };

        if (this.promo.PromoAvailableType === PromoAvailableTypeEnum.CustomUsers && this.customUsersFile) {
            this.readFileAsBase64(this.customUsersFile)
                .then(base64 => {
                    this.promo.CustomUsersExcelBase64 = base64;
                    submitPromo();
                })
                .catch(() => {
                    this.promo.StartedAt = startedAt;
                    this.promo.ValidUntil = endedAt;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'The Excel file could not be read' });
                });
            return;
        }

        delete this.promo.CustomUsersExcelBase64;
        submitPromo();
    }

    checkIsActiveMenu(menuTab: MenuTab) {
        const allowedMenuTabs: Record<number, MenuTab[]> = {
            [MenuTab.PromoDetails]: [
                MenuTab.PromoDetails
            ],
            [MenuTab.Mechanics]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics
            ],
            [MenuTab.Validity]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity
            ],
            [MenuTab.Products]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity,
                MenuTab.Products
            ],
            [MenuTab.Locations]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity,
                MenuTab.Products,
                MenuTab.Locations
            ],
            [MenuTab.Preview]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity,
                MenuTab.Products,
                MenuTab.Locations,
                MenuTab.Preview
            ]
        };

        if (allowedMenuTabs[this.activeMenuTab]?.includes(menuTab)) {
            return true;
        }

        return false;
    }

    cancel() {
        this.changedShowAddEditPromotionSideBar(false);
    }

    getOrdersByPromoReport(promoId: number) {
        this.reportService.getOrdersByPromoReport({
            PromoId: promoId,
            TimezoneOffset: Utils.getTimezoneOffset()
        }, this.messageService)
            .then(data => {
                Utils.saveFileResponse(data, 'Report-Bookings ' + '.xlsx');
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
}
